import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { BREAKPOINTS, Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { useIsMobile, useMedia } from 'pricing-pages-ui-components/hooks/useMedia';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SolutionCardLayoutUI = ({
  reverse,
  title,
  subheading,
  features,
  footer,
  image
}) => {
  const isMobile = useIsMobile();
  const isMd = useMedia(`(min-width: ${BREAKPOINTS.md}px)`);
  const heading = /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    marginInline: "400",
    paddingInline: "1400",
    justifyContent: "center",
    gap: "200",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h3",
      typography: "heading-300",
      children: title
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      children: subheading
    })]
  });
  const currentOrder = reverse || isMobile ? [image, heading] : [heading, image];
  return /*#__PURE__*/_jsxs(CardWrapper, {
    children: [/*#__PURE__*/_jsx(CardSection, {
      paddingInline: "0",
      paddingBlockStart: "0",
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? '1000' : '0',
        children: currentOrder.map((item, index) => {
          return /*#__PURE__*/_jsx(Flex, {
            flex: 1,
            children: item
          }, `solution-card-hero-${index}`);
        })
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      padding: "0",
      children: /*#__PURE__*/_jsx(Grid, {
        marginInline: "400",
        children: features.map(({
          icon,
          name,
          description
        }, index) => {
          return /*#__PURE__*/_jsx(GridItem, {
            size: {
              xs: 12,
              // >= 0
              sm: 6,
              // >= 544px
              md: 3 // >= 768px
            },
            paddingInline: "0",
            children: /*#__PURE__*/_jsxs(Flex, {
              flexDirection: "row",
              alignItems: "start",
              borderWidth: "100",
              borderColor: "border-core-subtle",
              borderInlineStartStyle: index > 0 && isMd ? 'solid' : 'none',
              blockSize: "100%",
              paddingInline: "400",
              gap: "400",
              children: [/*#__PURE__*/_jsx(View, {
                inlineSize: "32px",
                children: icon
              }), /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx(Flex, {
                  blockSize: "32px",
                  alignItems: "center",
                  children: /*#__PURE__*/_jsx(Text, {
                    as: "h4",
                    typography: "heading-200",
                    children: name
                  })
                }), /*#__PURE__*/_jsx(Text, {
                  as: "p",
                  children: description
                })]
              })]
            })
          }, `feature-${index}`);
        })
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      marginInline: "400",
      paddingInline: "1400",
      children: footer
    })]
  });
};
export default SolutionCardLayoutUI;